import * as React from "react";
import classnames from "classnames";
import { Modal, Price, Button } from "@grandvisionhq/common";
import { Select } from "@grandvisionhq/forms";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
/* empty css                    */
const ChangeQuantityModal = ({
  className,
  onCancel,
  onEditQuantity,
  maxQuantity,
  isLoading,
  errorMessage,
  totalPricePerInstallment
}) => {
  const intl = useIntl();
  const quantityRange = Array.from({ length: maxQuantity }, (_, i) => i + 1);
  const formattedQuantities = quantityRange.reduce((acc, quantity2) => {
    const quantityLabel = quantity2 === 1 ? intl.getLabel("products.box") : intl.getLabel("products.boxes");
    return {
      ...acc,
      [`${quantity2} ${quantityLabel}`]: quantity2
    };
  }, {});
  const initialOptionKey = Object.keys(formattedQuantities)[0] ?? "";
  const [quantity, setQuantity] = React.useState(formattedQuantities[initialOptionKey]);
  const initialValue = React.useMemo(() => ({ value: initialOptionKey }), [initialOptionKey]);
  const onSelectChange = (quantity2) => {
    setQuantity(quantity2);
  };
  const handleSubmit = () => {
    if (quantity) {
      onEditQuantity(quantity);
    }
  };
  const buttonCaption = isLoading ? intl.getLabel("common.loadingText") : intl.getLabel("account.action.changeQuantity");
  const footerButton = /* @__PURE__ */ React.createElement(
    Button,
    {
      caption: buttonCaption,
      className: "edit-ccc__button",
      "data-t": "edit-ccc-modal-confirm",
      disabled: isLoading,
      onClick: handleSubmit
    }
  );
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      showIcon: true,
      isOpen: true,
      onModalClose: onCancel,
      title: intl.getLabel("account.ccc.editSubscription.title"),
      footer: footerButton,
      className: classnames("edit-ccc", className)
    },
    /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, intl.getFormattedLabel("account.ccc.editSubscription.info", { parseLink: true })),
    errorMessage && /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, errorMessage),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "edit-quantity-select",
        name: "edit-quantity-select",
        className: "edit-ccc__select",
        options: formattedQuantities,
        initialState: initialValue,
        onChange: onSelectChange,
        label: intl.getLabel("account.ccc.editSubscription.select.label")
      }
    ),
    quantity ? /* @__PURE__ */ React.createElement("p", null, intl.getLabel("account.ccc.editSubscription.newPrice"), " ", /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement(
      Price,
      {
        value: totalPricePerInstallment.amount * quantity,
        currency: totalPricePerInstallment.currency
      }
    ))) : null
  );
};
export {
  ChangeQuantityModal as default
};
//# sourceMappingURL=ChangeQuantity.js.map
